

// import React from 'react';

// export default function BracquetsLanding() {
//   return (
//     <div className="font-sans text-white bg-slate-900 scroll-smooth h-screen overflow-y-scroll">
//       {/* Navigation */}
//       <header className="fixed top-0 left-0 w-full z-20 flex items-center justify-between px-6 py-4 bg-transparent backdrop-blur-sm">
//         <h1 className="text-2xl font-serif tracking-widest text-white">Bracquets</h1>
//         <nav className="hidden md:flex space-x-8 text-sm uppercase tracking-wide">
//           <a href="#section01" className="hover:text-amber-300 transition">Members</a>
//           <a href="#section02" className="hover:text-amber-300 transition">Coaches</a>
//           <a href="#section03" className="hover:text-amber-300 transition">Management</a>
//         </nav>
//         <a
//           href="#signup"
//           className="px-5 py-2 bg-amber-300 text-slate-900 font-medium rounded-lg hover:bg-amber-400 transition"
//         >
//           Sign Up
//         </a>
//         {/* Mobile Toggle */}
//         <button className="md:hidden ml-4 p-2 focus:outline-none" aria-label="Toggle Menu">
//           <svg
//             className="w-6 h-6 text-white"
//             fill="none"
//             stroke="currentColor"
//             viewBox="0 0 24 24"
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               strokeWidth={2}
//               d="M4 6h16M4 12h16M4 18h16"
//             />
//           </svg>
//         </button>
//       </header>

//       {/* Hero Section */}
//       <section
//         id="hero"
//         className="relative snap-start h-screen bg-cover bg-center flex items-center justify-center"
//         style={{ backgroundImage: "url('/hero-landing.png')" }}
//       >
//         <div className="absolute inset-0 bg-slate-900 bg-opacity-70" />
//         <div className="relative z-10 max-w-3xl text-center px-6 space-y-8">
//           <p className="text-amber-300 uppercase text-sm tracking-widest font-medium">An Intelligent Experience</p>
//           <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl leading-tight font-light">
//             Redefining Racquet Club<br />Excellence
//           </h1>
//           <a
//             href="#section01"
//             className="inline-flex items-center text-amber-300 uppercase text-sm tracking-wider hover:opacity-80 transition font-medium"
//           >
//             Scroll Down
//             <svg
//               className="w-4 h-4 ml-2 animate-bounce"
//               fill="none"
//               stroke="currentColor"
//               viewBox="0 0 24 24"
//             >
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
//             </svg>
//           </a>
//         </div>
//         {/* Side Indicator */}
//         <div className="hidden lg:flex absolute right-8 bottom-1/2 transform translate-y-1/2 flex-col items-center text-amber-300 text-xs tracking-widest space-y-3">
//           <span className="font-medium">START</span>
//           <div className="w-px h-16 bg-amber-300 opacity-50"></div>
//           <div className="space-y-2 text-right">
//             <div>01</div>
//             <div>02</div>
//             <div>03</div>
//           </div>
//         </div>
//       </section>

//       <main>
//         {/* Section Component */}
//         {[
//           {
//             id: 'section01',
//             tag: 'Tennis Excellence',
//             title: 'Members',
//             text: 'Browse our exclusive range of racquets, balls, and accessories curated for players of all levels.',
//             img: '/member2_mock@3x.png',
//             reverse: false,
//           },
//           {
//             id: 'section02',
//             tag: 'Professional Training',
//             title: 'Coaching Excellence',
//             text: 'Connect with top instructors for personalized coaching that takes your game to the next level.',
//             img: '/member2_mock@3x.png',
//             reverse: true,
//           },
//           {
//             id: 'section03',
//             tag: 'Club Operations',
//             title: 'Smart Management',
//             text: 'Streamlined booking, member management, and facilities coordination all in one intelligent platform.',
//             img: '/comp_phone_mgmt.png',
//             reverse: false,
//           },
//         ].map(({ id, tag, title, text, img, reverse }) => (
//           <section
//             key={id}
//             id={id}
//             className={`snap-start min-h-screen py-20 px-6 md:px-12 lg:px-20 flex flex-col ${
//               reverse ? 'lg:flex-row-reverse' : 'lg:flex-row'
//             } items-center justify-center gap-12 lg:gap-16 bg-slate-900`}
//           >
//             {img && (
//               <div className="flex-1 flex justify-center">
//                 <img
//                   src={img}
//                   alt={title}
//                   className="w-full max-w-md lg:max-w-lg rounded-2xl shadow-2xl hover:scale-105 transition-transform duration-300"
//                 />
//               </div>
//             )}
//             <div className="flex-1 max-w-2xl text-center lg:text-left space-y-6">
//               <p className="text-amber-300 uppercase text-sm tracking-wider font-medium">{tag}</p>
//               <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-tight">{title}</h2>
//               <p className="text-lg leading-relaxed text-gray-300 max-w-xl">{text}</p>
//               <a href="#" className="inline-flex items-center text-amber-300 hover:text-amber-400 transition group">
//                 <span className="font-medium tracking-wide">Learn More</span>
//                 <svg
//                   className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M17 8l4 4m0 0l-4 4m4-4H3"
//                   />
//                 </svg>
//               </a>
//             </div>
//           </section>
//         ))}

//         {/* Sign-Up Form */}
//         <section id="signup" className="snap-start min-h-screen py-20 px-6 md:px-12 bg-slate-800 flex items-center justify-center">
//           <div className="w-full max-w-md">
//             <div className="text-center mb-8">
//               <h2 className="font-serif text-3xl md:text-4xl mb-4">Join Bracquets</h2>
//               <p className="text-gray-300">Experience the future of racquet club management</p>
//             </div>
//             <div className="p-8 bg-slate-700 bg-opacity-80 rounded-2xl shadow-2xl backdrop-blur-sm">
//               <div className="space-y-5">
//                 {['First Name', 'Last Name', 'Email', 'Club Name'].map((ph, i) => (
//                   <div key={i}>
//                     <input
//                       type={ph === 'Email' ? 'email' : 'text'}
//                       placeholder={ph}
//                       className="w-full px-4 py-3 bg-slate-600 bg-opacity-80 border border-slate-500 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-300 focus:border-transparent transition placeholder-gray-400 text-white"
//                     />
//                   </div>
//                 ))}
//                 <button className="w-full py-3 px-6 bg-amber-300 text-slate-900 rounded-lg font-semibold hover:bg-amber-400 transition-colors duration-200 shadow-lg">
//                   Get Started
//                 </button>
//               </div>
//             </div>
//           </div>
//         </section>
//       </main>

//       {/* Footer */}
//       <footer className="bg-[#FFF]-950 text-gray-400 py-16 px-6">
//         <div className="max-w-6xl mx-auto">
//           <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
//             <div className="md:col-span-2">
//               <h3 className="text-white text-2xl font-serif mb-4">Bracquets</h3>
//               <p className="text-gray-300 leading-relaxed max-w-md">
//                 Elevating your racquet club experience with intelligent coaching, top-tier equipment, and seamless management.
//               </p>
//             </div>
//             <div>
//               <h4 className="text-white text-sm uppercase tracking-wide font-medium mb-4">Navigation</h4>
//               <ul className="space-y-3">
//                 <li><a href="#section01" className="hover:text-amber-300 transition">Members</a></li>
//                 <li><a href="#section02" className="hover:text-amber-300 transition">Coaching</a></li>
//                 <li><a href="#section03" className="hover:text-amber-300 transition">Management</a></li>
//                 <li><a href="#signup" className="hover:text-amber-300 transition">Sign Up</a></li>
//               </ul>
//             </div>
//             <div>
//               <h4 className="text-white text-sm uppercase tracking-wide font-medium mb-4">Contact</h4>
//               <div className="space-y-2 text-sm">
//                 <p>123 Courtside Avenue<br />Tennis Valley, TX 77494</p>
//                 <p>contact@bracquets.com</p>
//                 <p>(555) 123-4567</p>
//               </div>
//             </div>
//           </div>
//           <div className="border-t border-slate-800 pt-8 text-center text-sm text-gray-500">
//             © {new Date().getFullYear()} Bracquets. All rights reserved.
//           </div>
//         </div>
//       </footer>
//     </div>
//   );
// }


// import React from 'react';

// export default function BracquetsLanding() {
//   return (
//     <div className="font-sans text-white" style={{ background: 'linear-gradient(to bottom, #003333 0%, #002828 50%, #001d1d 100%)' }}>
//       {/* Navigation */}
//       <header className="fixed top-0 left-0 w-full z-20 flex items-center justify-between px-6 py-4 bg-transparent backdrop-blur-sm">
//         <h1 className="text-2xl font-serif tracking-widest text-white">Bracquets</h1>
//         <nav className="hidden md:flex space-x-8 text-sm uppercase tracking-wide">
//           <a href="#section01" style={{ color: '#FFDD90' }} className="hover:opacity-80 transition">Members</a>
//           <a href="#section02" style={{ color: '#FFDD90' }} className="hover:opacity-80 transition">Coaches</a>
//           <a href="#section03" style={{ color: '#FFDD90' }} className="hover:opacity-80 transition">Operations</a>
//         </nav>
//         <a
//           href="#signup"
//           style={{ backgroundColor: '#FFDD90', color: '#003333' }}
//           className="px-5 py-2 font-medium rounded-lg hover:opacity-90 transition"
//         >
//           Sign Up
//         </a>
//       </header>

//       {/* Hero Section */}
//       <section
//         id="hero"
//         className="relative h-screen bg-cover bg-center"
//         style={{ backgroundImage: "url('/hero-landing.png')" }}
//       >
//         <div className="absolute inset-0" style={{ backgroundColor: '#003333', opacity: 0.7 }} />
//         <div className="relative z-10 h-full px-6 md:px-12 lg:px-20">
//           <div className="h-full flex flex-col justify-center pt-16">
//             <div className="max-w-xs mb-8">
//               <div className="w-16 h-px mb-4" style={{ backgroundColor: '#FFDD90' }}></div>
//               <p style={{ color: '#FFDD90' }} className="uppercase text-sm tracking-widest font-medium">An Intelligent Experience</p>
//             </div>
//             <h1 className="text-5xl md:text-6xl lg:text-7xl leading-tight font-light max-w-2xl" style={{ fontFamily: 'Adamina, serif' }}>
//               Redefining Racquet<br />Club Excellence
//             </h1>
//             <div className="mt-12">
//               <a
//                 href="#section01"
//                 style={{ color: '#FFDD90' }}
//                 className="inline-flex items-center uppercase text-sm tracking-wider hover:opacity-80 transition font-medium"
//               >
//                 scroll down
//                 <svg
//                   className="w-4 h-4 ml-2"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
//                 </svg>
//               </a>
//             </div>
//           </div>
//         </div>
//         {/* Side Indicator */}
//         <div className="hidden lg:flex absolute right-8 top-1/2 transform -translate-y-1/2 flex-col items-center text-xs tracking-widest space-y-3" style={{ color: '#FFDD90' }}>
//           <span className="font-medium">Start</span>
//           <div className="w-px h-20 opacity-50" style={{ backgroundColor: '#FFDD90' }}></div>
//           <div className="space-y-3 text-right">
//             <div>01</div>
//             <div>02</div>
//             <div>03</div>
//           </div>
//         </div>
//       </section>

//       {/* Section 01 - Members */}
//       <section id="section01" className="min-h-screen py-20 px-6 md:px-12 lg:px-20 flex flex-col lg:flex-row items-center justify-center gap-12 lg:gap-16">
//         {/* Large Number */}
//         <div className="absolute left-8 top-1/2 transform -translate-y-1/2 opacity-10 pointer-events-none hidden lg:block">
//           <span className="text-9xl font-bold text-white">01</span>
//         </div>
        
//         <div className="flex-1 flex justify-center relative z-10">
//           <img
//             src="/member2_mock@3x.png"
//             alt="Members App"
//             className="w-full max-w-md lg:max-w-lg"
//           />
//         </div>
//         <div className="flex-1 max-w-2xl text-center lg:text-left space-y-6 relative z-10">
//           <p style={{ color: '#FFDD90' }} className="uppercase text-sm tracking-wider font-medium">Get Started</p>
//           <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-tight">Members</h2>
//           <p className="text-lg leading-relaxed text-gray-300 max-w-xl">
//             Determining what level of play you can be is as important as when planning future fees. This hiring level guide will help you plan fees according to different live settings and by various activities like Ai tools and features take. Know your pace of play – tackle, moderate, advanced and fast pace. 4 guided mode guidance.
//           </p>
//           <a href="#" style={{ color: '#FFDD90' }} className="inline-flex items-center hover:opacity-80 transition group">
//             <span className="font-medium tracking-wide">read more</span>
//             <svg
//               className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform"
//               fill="none"
//               stroke="currentColor"
//               viewBox="0 0 24 24"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth={2}
//                 d="M17 8l4 4m0 0l-4 4m4-4H3"
//               />
//             </svg>
//           </a>
//         </div>
//       </section>

//       {/* Section 02 - Coaches */}
//       <section id="section02" className="min-h-screen py-20 px-6 md:px-12 lg:px-20 flex flex-col lg:flex-row-reverse items-center justify-center gap-12 lg:gap-16">
//         {/* Large Number */}
//         <div className="absolute left-8 top-1/2 transform -translate-y-1/2 opacity-10 pointer-events-none hidden lg:block">
//           <span className="text-9xl font-bold text-white">02</span>
//         </div>
        
//         <div className="flex-1 flex justify-center relative z-10">
//           <img
//             src="/member2_mock@3x.png"
//             alt="Coaches App"
//             className="w-full max-w-md lg:max-w-lg"
//           />
//         </div>
//         <div className="flex-1 max-w-2xl text-center lg:text-left space-y-6 relative z-10">
//           <p style={{ color: '#FFDD90' }} className="uppercase text-sm tracking-wider font-medium">Hitting Essentials</p>
//           <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-tight">Coaches</h2>
//           <p className="text-lg leading-relaxed text-gray-300 max-w-xl">
//             The nice thing about beginning hiking is that you don't really need any special gear. You can probably get away with shoes you already have, let's start with clothing. A typical mistake hiking beginners make is wearing jeans and regular clothes, which will get heavy and chafe or run on your body.
//           </p>
//           <a href="#" style={{ color: '#FFDD90' }} className="inline-flex items-center hover:opacity-80 transition group">
//             <span className="font-medium tracking-wide">read more</span>
//             <svg
//               className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform"
//               fill="none"
//               stroke="currentColor"
//               viewBox="0 0 24 24"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth={2}
//                 d="M17 8l4 4m0 0l-4 4m4-4H3"
//               />
//             </svg>
//           </a>
//         </div>
//       </section>

//       {/* Section 03 - Management */}
//       <section id="section03" className="min-h-screen py-20 px-6 md:px-12 lg:px-20 flex flex-col lg:flex-row items-center justify-center gap-12 lg:gap-16">
//         {/* Large Number */}
//         <div className="absolute left-8 top-1/2 transform -translate-y-1/2 opacity-10 pointer-events-none hidden lg:block">
//           <span className="text-9xl font-bold text-white">03</span>
//         </div>
        
//         <div className="flex-1 flex justify-center relative z-10">
//           <img
//             src="/comp_phone_mgmt.png"
//             alt="Management App"
//             className="w-full max-w-md lg:max-w-lg"
//           />
//         </div>
//         <div className="flex-1 max-w-2xl text-center lg:text-left space-y-6 relative z-10">
//           <p style={{ color: '#FFDD90' }} className="uppercase text-sm tracking-wider font-medium">Where You Go Is The Key</p>
//           <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-tight">Management</h2>
//           <p className="text-lg leading-relaxed text-gray-300 max-w-xl">
//             To start print out the hiking guide and map. If it's raining, throw them in a Zip-lock bag. Read over the guide, study the map, and have a good idea of what to expect. I like to know what my next landmark is as I hike for example: I'll head to the guide and know that say ¼ mile I make a right turn on the trail and the trail goes...
//           </p>
//           <a href="#" style={{ color: '#FFDD90' }} className="inline-flex items-center hover:opacity-80 transition group">
//             <span className="font-medium tracking-wide">read more</span>
//             <svg
//               className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform"
//               fill="none"
//               stroke="currentColor"
//               viewBox="0 0 24 24"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth={2}
//                 d="M17 8l4 4m0 0l-4 4m4-4H3"
//               />
//             </svg>
//           </a>
//         </div>
//       </section>

//       {/* Sign-Up Form */}
//       <section id="signup" className="min-h-screen py-20 px-6 md:px-12 flex items-center justify-center">
//         <div className="w-full max-w-md">
//           <div className="p-8 rounded-2xl shadow-2xl backdrop-blur-sm" style={{ backgroundColor: 'rgba(0, 26, 26, 0.8)' }}>
//             <div className="space-y-5">
//               <input
//                 type="text"
//                 placeholder="First Name"
//                 className="w-full px-4 py-3 border border-gray-500 rounded-lg focus:outline-none transition placeholder-gray-400 text-white"
//                 style={{ backgroundColor: 'rgba(0, 51, 51, 0.6)' }}
//               />
//               <input
//                 type="text"
//                 placeholder="Last Name"
//                 className="w-full px-4 py-3 border border-gray-500 rounded-lg focus:outline-none transition placeholder-gray-400 text-white"
//                 style={{ backgroundColor: 'rgba(0, 51, 51, 0.6)' }}
//               />
//               <input
//                 type="email"
//                 placeholder="Email"
//                 className="w-full px-4 py-3 border border-gray-500 rounded-lg focus:outline-none transition placeholder-gray-400 text-white"
//                 style={{ backgroundColor: 'rgba(0, 51, 51, 0.6)' }}
//               />
//               <input
//                 type="text"
//                 placeholder="Company/Club"
//                 className="w-full px-4 py-3 border border-gray-500 rounded-lg focus:outline-none transition placeholder-gray-400 text-white"
//                 style={{ backgroundColor: 'rgba(0, 51, 51, 0.6)' }}
//               />
//               <button 
//                 style={{ backgroundColor: '#FFDD90', color: '#003333' }}
//                 className="w-full py-3 px-6 rounded-lg font-semibold hover:opacity-90 transition-opacity duration-200 shadow-lg"
//               >
//                 Sign Up
//               </button>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Footer - Simple version to match design */}
//       <footer className="py-16 px-6 text-gray-400 text-center">
//         <div className="text-sm">
//           © {new Date().getFullYear()} Bracquets. All rights reserved.
//         </div>
//       </footer>
//     </div>
//   );
// }


// import React from 'react';

// export default function BracquetsLanding() {
//   return (
//     <div className="font-sans text-white" style={{ background: 'linear-gradient(to bottom, #003333 0%, #002828 50%, #001d1d 100%)' }}>
//       {/* Navigation */}
//       <header className="fixed top-0 left-0 w-full z-20 flex items-center justify-between px-6 py-4 bg-transparent backdrop-blur-sm">
//         <h1 className="text-2xl font-serif tracking-widest text-white">Bracquets</h1>
//         <nav className="hidden md:flex space-x-8 text-sm uppercase tracking-wide">
//           <a href="#section01" style={{ color: '#FFDD90' }} className="hover:opacity-80 transition">Equipment</a>
//           <a href="#section02" style={{ color: '#FFDD90' }} className="hover:opacity-80 transition">About us</a>
//           <a href="#section03" style={{ color: '#FFDD90' }} className="hover:opacity-80 transition">Blog</a>
//         </nav>
//         <a
//           href="#signup"
//           style={{ backgroundColor: '#FFDD90', color: '#003333' }}
//           className="px-5 py-2 font-medium rounded-lg hover:opacity-90 transition"
//         >
//           Sign Up
//         </a>
//       </header>

//       {/* Hero Section */}
//       <section
//         id="hero"
//         className="relative h-screen bg-cover bg-center"
//         style={{ backgroundImage: "url('/hero-landing.png')" }}
//       >
//         <div className="absolute inset-0" style={{ background: 'linear-gradient(to bottom, rgba(0, 51, 51, 0.9) 0%, rgba(0, 51, 51, 0.7) 50%, rgba(0, 51, 51, 0.9) 100%)' }} />
//         <div className="relative z-10 h-full px-6 md:px-12 lg:px-20">
//           <div className="pt-32 lg:pt-40">
//             <div className="mb-8">
//               <div className="w-20 h-px mb-4" style={{ backgroundColor: '#FFDD90' }}></div>
//               <p style={{ color: '#FFDD90' }} className="uppercase text-sm tracking-widest font-medium">An Intelligent Experience</p>
//             </div>
//             <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl leading-tight font-light max-w-2xl" style={{ fontFamily: 'Adamina, serif' }}>
//               Redefining Racquet<br />Club Excellence
//             </h1>
//             <div className="mt-8">
//               <a
//                 href="#section01"
//                 style={{ color: '#FFDD90' }}
//                 className="inline-flex items-center lowercase text-sm tracking-wider hover:opacity-80 transition font-medium"
//               >
//                 scroll down
//                 <svg
//                   className="w-4 h-4 ml-2"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
//                 </svg>
//               </a>
//             </div>
//           </div>
//         </div>
//         {/* Side Indicator */}
//         <div className="hidden lg:flex absolute right-8 top-1/2 transform -translate-y-1/2 flex-col items-center text-xs tracking-widest space-y-3" style={{ color: '#FFDD90' }}>
//           <span className="font-medium">Start</span>
//           <div className="w-px h-20 opacity-50" style={{ backgroundColor: '#FFDD90' }}></div>
//           <div className="space-y-3 text-right">
//             <div>01</div>
//             <div>02</div>
//             <div>03</div>
//           </div>
//         </div>
//       </section>

//       {/* Section 01 - Members */}
//       <section id="section01" className="relative min-h-screen py-20 px-6 md:px-12 lg:px-20 flex flex-col lg:flex-row items-center justify-center gap-12 lg:gap-16">
//         {/* Large Number */}
//         <div className="absolute left-8 top-1/2 transform -translate-y-1/2 opacity-10 pointer-events-none hidden lg:block">
//           <span className="text-9xl font-bold text-white">01</span>
//         </div>
        
//         <div className="flex-1 flex justify-center relative z-10">
//           <img
//             src="/member2_mock@3x.png"
//             alt="Members App"
//             className="w-full max-w-md lg:max-w-lg"
//           />
//         </div>
//         <div className="flex-1 max-w-2xl text-center lg:text-left space-y-6 relative z-10">
//           <p style={{ color: '#FFDD90' }} className="uppercase text-sm tracking-wider font-medium">Get Started</p>
//           <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-tight">Members</h2>
//           <p className="text-lg leading-relaxed text-gray-300 max-w-xl">
//             Determining what level of play you can be is as important as when planning future fees. This hiring level guide will help you plan fees according to different live settings and by various activities like Ai tools and features take. Know your pace of play – tackle, moderate, advanced and fast pace. 4 guided mode guidance.
//           </p>
//           <a href="#" style={{ color: '#FFDD90' }} className="inline-flex items-center hover:opacity-80 transition group">
//             <span className="font-medium tracking-wide">read more</span>
//             <svg
//               className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform"
//               fill="none"
//               stroke="currentColor"
//               viewBox="0 0 24 24"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth={2}
//                 d="M17 8l4 4m0 0l-4 4m4-4H3"
//               />
//             </svg>
//           </a>
//         </div>
//       </section>

//       {/* Section 02 - Coaches */}
//       <section id="section02" className="relative min-h-screen py-20 px-6 md:px-12 lg:px-20 flex flex-col lg:flex-row-reverse items-center justify-center gap-12 lg:gap-16">
//         {/* Large Number */}
//         <div className="absolute left-8 top-1/2 transform -translate-y-1/2 opacity-10 pointer-events-none hidden lg:block">
//           <span className="text-9xl font-bold text-white">02</span>
//         </div>
        
//         <div className="flex-1 flex justify-center relative z-10">
//           <img
//             src="/member2_mock@3x.png"
//             alt="Coaches App"
//             className="w-full max-w-md lg:max-w-lg"
//           />
//         </div>
//         <div className="flex-1 max-w-2xl text-center lg:text-left space-y-6 relative z-10">
//           <p style={{ color: '#FFDD90' }} className="uppercase text-sm tracking-wider font-medium">Hitting Essentials</p>
//           <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-tight">Coaches</h2>
//           <p className="text-lg leading-relaxed text-gray-300 max-w-xl">
//             The nice thing about beginning hiking is that you don't really need any special gear. You can probably get away with shoes you already have, let's start with clothing. A typical mistake hiking beginners make is wearing jeans and regular clothes, which will get heavy and chafe or run on your body.
//           </p>
//           <a href="#" style={{ color: '#FFDD90' }} className="inline-flex items-center hover:opacity-80 transition group">
//             <span className="font-medium tracking-wide">read more</span>
//             <svg
//               className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform"
//               fill="none"
//               stroke="currentColor"
//               viewBox="0 0 24 24"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth={2}
//                 d="M17 8l4 4m0 0l-4 4m4-4H3"
//               />
//             </svg>
//           </a>
//         </div>
//       </section>

//       {/* Section 03 - Management */}
//       <section id="section03" className="relative min-h-screen py-20 px-6 md:px-12 lg:px-20 flex flex-col lg:flex-row items-center justify-center gap-12 lg:gap-16">
//         {/* Large Number */}
//         <div className="absolute left-8 top-1/2 transform -translate-y-1/2 opacity-10 pointer-events-none hidden lg:block">
//           <span className="text-9xl font-bold text-white">03</span>
//         </div>
        
//         <div className="flex-1 flex justify-center relative z-10">
//           <img
//             src="/comp_phone_mgmt.png"
//             alt="Management App"
//             className="w-full max-w-md lg:max-w-lg"
//           />
//         </div>
//         <div className="flex-1 max-w-2xl text-center lg:text-left space-y-6 relative z-10">
//           <p style={{ color: '#FFDD90' }} className="uppercase text-sm tracking-wider font-medium">Where You Go Is The Key</p>
//           <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-tight">Management</h2>
//           <p className="text-lg leading-relaxed text-gray-300 max-w-xl">
//             To start print out the hiking guide and map. If it's raining, throw them in a Zip-lock bag. Read over the guide, study the map, and have a good idea of what to expect. I like to know what my next landmark is as I hike for example: I'll head to the guide and know that say ¼ mile I make a right turn on the trail and the trail goes...
//           </p>
//           <a href="#" style={{ color: '#FFDD90' }} className="inline-flex items-center hover:opacity-80 transition group">
//             <span className="font-medium tracking-wide">read more</span>
//             <svg
//               className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform"
//               fill="none"
//               stroke="currentColor"
//               viewBox="0 0 24 24"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth={2}
//                 d="M17 8l4 4m0 0l-4 4m4-4H3"
//               />
//             </svg>
//           </a>
//         </div>
//       </section>

//       {/* Sign-Up Form */}
//       <section id="signup" className="min-h-screen py-20 px-6 md:px-12 flex items-center justify-center">
//         <div className="w-full max-w-md">
//           <div className="p-8 rounded-2xl shadow-2xl backdrop-blur-sm" style={{ backgroundColor: 'rgba(0, 26, 26, 0.8)' }}>
//             <div className="space-y-5">
//               <input
//                 type="text"
//                 placeholder="First Name"
//                 className="w-full px-4 py-3 border border-gray-500 rounded-lg focus:outline-none transition placeholder-gray-400 text-white"
//                 style={{ backgroundColor: 'rgba(0, 51, 51, 0.6)' }}
//               />
//               <input
//                 type="text"
//                 placeholder="Last Name"
//                 className="w-full px-4 py-3 border border-gray-500 rounded-lg focus:outline-none transition placeholder-gray-400 text-white"
//                 style={{ backgroundColor: 'rgba(0, 51, 51, 0.6)' }}
//               />
//               <input
//                 type="email"
//                 placeholder="Email"
//                 className="w-full px-4 py-3 border border-gray-500 rounded-lg focus:outline-none transition placeholder-gray-400 text-white"
//                 style={{ backgroundColor: 'rgba(0, 51, 51, 0.6)' }}
//               />
//               <input
//                 type="text"
//                 placeholder="Company/Club"
//                 className="w-full px-4 py-3 border border-gray-500 rounded-lg focus:outline-none transition placeholder-gray-400 text-white"
//                 style={{ backgroundColor: 'rgba(0, 51, 51, 0.6)' }}
//               />
//               <button 
//                 style={{ backgroundColor: '#FFDD90', color: '#003333' }}
//                 className="w-full py-3 px-6 rounded-lg font-semibold hover:opacity-90 transition-opacity duration-200 shadow-lg"
//               >
//                 Sign Up
//               </button>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Footer */}
//       <footer className="py-16 px-6 text-gray-400" style={{ backgroundColor: '#001111' }}>
//         <div className="max-w-6xl mx-auto">
//           <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
//             <div className="md:col-span-2">
//               <h3 className="text-white text-2xl font-serif mb-4">Bracquets</h3>
//               <p className="text-gray-300 leading-relaxed max-w-md">
//                 Elevating your racquet club experience with intelligent coaching, top-tier equipment, and seamless management.
//               </p>
//             </div>
//             <div>
//               <h4 className="text-white text-sm uppercase tracking-wide font-medium mb-4">Navigation</h4>
//               <ul className="space-y-3">
//                 <li><a href="#section01" style={{ color: '#FFDD90' }} className="hover:opacity-80 transition">Members</a></li>
//                 <li><a href="#section02" style={{ color: '#FFDD90' }} className="hover:opacity-80 transition">Coaching</a></li>
//                 <li><a href="#section03" style={{ color: '#FFDD90' }} className="hover:opacity-80 transition">Management</a></li>
//                 <li><a href="#signup" style={{ color: '#FFDD90' }} className="hover:opacity-80 transition">Sign Up</a></li>
//               </ul>
//             </div>
//             <div>
//               <h4 className="text-white text-sm uppercase tracking-wide font-medium mb-4">Contact</h4>
//               <div className="space-y-2 text-sm">
//                 <p>123 Courtside Avenue<br />Tennis Valley, TX 77494</p>
//                 <p>contact@bracquets.com</p>
//                 <p>(555) 123-4567</p>
//               </div>
//             </div>
//           </div>
//           <div className="border-t pt-8 text-center text-sm text-gray-500" style={{ borderColor: 'rgba(0, 51, 51, 0.5)' }}>
//             © {new Date().getFullYear()} Bracquets. All rights reserved.
//           </div>
//         </div>
//       </footer>
//     </div>
//   );
// }


// import React from 'react';

// export default function BracquetsLanding() {
//   return (
//     <div className="font-sans text-white" style={{ background: 'linear-gradient(180deg, #252525 0%, #1a1a1a 25%, #111111 50%, #0a0a0a 75%, #000000 100%)' }}>
//       {/* Navigation */}
//       <header className="fixed top-0 left-0 w-full z-20 flex items-center justify-between px-6 py-4 bg-transparent backdrop-blur-sm">
//         <h1 className="text-2xl font-serif tracking-widest text-white">Bracquets</h1>
//         <nav className="hidden md:flex space-x-8 text-sm uppercase tracking-wide">
//           <a href="#section01" style={{ color: '#E2C163' }} className="hover:opacity-80 transition">Equipment</a>
//           <a href="#section02" style={{ color: '#E2C163' }} className="hover:opacity-80 transition">About us</a>
//           <a href="#section03" style={{ color: '#E2C163' }} className="hover:opacity-80 transition">Blog</a>
//         </nav>
//         <a
//           href="#signup"
//           style={{ backgroundColor: '#E2C163', color: '#252525' }}
//           className="px-5 py-2 font-medium rounded-lg hover:opacity-90 transition"
//         >
//           Sign Up
//         </a>
//       </header>

//       {/* Hero Section */}
//       <section
//         id="hero"
//         className="relative h-screen bg-cover bg-center"
//         style={{ backgroundImage: "url('/hero-landing.png')" }}
//       >
//         <div className="absolute inset-0" style={{ background: 'linear-gradient(to bottom, rgba(37, 37, 37, 0.9) 0%, rgba(37, 37, 37, 0.7) 50%, rgba(37, 37, 37, 0.9) 100%)' }} />
//         <div className="relative z-10 h-full px-6 md:px-12 lg:px-20">
//           <div className="pt-32 lg:pt-40">
//             <div className="mb-8">
//               <div className="w-20 h-px mb-4" style={{ backgroundColor: '#E2C163' }}></div>
//               <p style={{ color: '#E2C163' }} className="uppercase text-sm tracking-widest font-medium">An Intelligent Experience</p>
//             </div>
//             <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl leading-tight font-light max-w-2xl" style={{ fontFamily: 'Adamina, serif' }}>
//               Redefining Racquet<br />Club Excellence
//             </h1>
//             <div className="mt-8">
//               <a
//                 href="#section01"
//                 style={{ color: '#E2C163' }}
//                 className="inline-flex items-center lowercase text-sm tracking-wider hover:opacity-80 transition font-medium"
//               >
//                 scroll down
//                 <svg
//                   className="w-4 h-4 ml-2"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
//                 </svg>
//               </a>
//             </div>
//           </div>
//         </div>
//         {/* Side Indicator */}
//         <div className="hidden lg:flex absolute right-8 top-1/2 transform -translate-y-1/2 flex-col items-center text-xs tracking-widest space-y-3" style={{ color: '#E2C163' }}>
//           <span className="font-medium">Start</span>
//           <div className="w-px h-20 opacity-50" style={{ backgroundColor: '#E2C163' }}></div>
//           <div className="space-y-3 text-right">
//             <div>01</div>
//             <div>02</div>
//             <div>03</div>
//           </div>
//         </div>
//       </section>

//       {/* Section 01 - Members */}
//       <section id="section01" className="relative min-h-screen py-20 px-6 md:px-12 lg:px-20 flex flex-col lg:flex-row items-center justify-center gap-12 lg:gap-16">
//         <div className="absolute inset-0" style={{ backgroundColor: 'rgba(37, 37, 37, 0.1)' }}></div>
//         {/* Large Number */}
//         <div className="absolute left-8 top-1/2 transform -translate-y-1/2 opacity-10 pointer-events-none hidden lg:block">
//           <span className="text-9xl font-bold text-white">01</span>
//         </div>
        
//         <div className="flex-1 flex justify-center relative z-10">
//           <img
//             src="/member2_mock@3x.png"
//             alt="Members App"
//             className="w-full max-w-md lg:max-w-lg"
//           />
//         </div>
//         <div className="flex-1 max-w-2xl text-center lg:text-left space-y-6 relative z-10">
//           <p style={{ color: '#E2C163' }} className="uppercase text-sm tracking-wider font-medium">Get Started</p>
//           <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-tight">Members</h2>
//           <p className="text-lg leading-relaxed text-gray-300 max-w-xl">
//             Determining what level of play you can be is as important as when planning future fees. This hiring level guide will help you plan fees according to different live settings and by various activities like Ai tools and features take. Know your pace of play – tackle, moderate, advanced and fast pace. 4 guided mode guidance.
//           </p>
//           <a href="#" style={{ color: '#E2C163' }} className="inline-flex items-center hover:opacity-80 transition group">
//             <span className="font-medium tracking-wide">read more</span>
//             <svg
//               className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform"
//               fill="none"
//               stroke="currentColor"
//               viewBox="0 0 24 24"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth={2}
//                 d="M17 8l4 4m0 0l-4 4m4-4H3"
//               />
//             </svg>
//           </a>
//         </div>
//       </section>

//       {/* Section 02 - Coaches */}
//       <section id="section02" className="relative min-h-screen py-20 px-6 md:px-12 lg:px-20 flex flex-col lg:flex-row-reverse items-center justify-center gap-12 lg:gap-16">
//         <div className="absolute inset-0" style={{ backgroundColor: 'rgba(0, 0, 0, 0.15)' }}></div>
//         {/* Large Number */}
//         <div className="absolute left-8 top-1/2 transform -translate-y-1/2 opacity-10 pointer-events-none hidden lg:block">
//           <span className="text-9xl font-bold text-white">02</span>
//         </div>
        
//         <div className="flex-1 flex justify-center relative z-10">
//           <img
//             src="/member2_mock@3x.png"
//             alt="Coaches App"
//             className="w-full max-w-md lg:max-w-lg"
//           />
//         </div>
//         <div className="flex-1 max-w-2xl text-center lg:text-left space-y-6 relative z-10">
//           <p style={{ color: '#E2C163' }} className="uppercase text-sm tracking-wider font-medium">Hitting Essentials</p>
//           <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-tight">Coaches</h2>
//           <p className="text-lg leading-relaxed text-gray-300 max-w-xl">
//             The nice thing about beginning hiking is that you don't really need any special gear. You can probably get away with shoes you already have, let's start with clothing. A typical mistake hiking beginners make is wearing jeans and regular clothes, which will get heavy and chafe or run on your body.
//           </p>
//           <a href="#" style={{ color: '#E2C163' }} className="inline-flex items-center hover:opacity-80 transition group">
//             <span className="font-medium tracking-wide">read more</span>
//             <svg
//               className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform"
//               fill="none"
//               stroke="currentColor"
//               viewBox="0 0 24 24"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth={2}
//                 d="M17 8l4 4m0 0l-4 4m4-4H3"
//               />
//             </svg>
//           </a>
//         </div>
//       </section>

//       {/* Section 03 - Management */}
//       <section id="section03" className="relative min-h-screen py-20 px-6 md:px-12 lg:px-20 flex flex-col lg:flex-row items-center justify-center gap-12 lg:gap-16">
//         <div className="absolute inset-0" style={{ backgroundColor: 'rgba(0, 0, 0, 0.25)' }}></div>
//         {/* Large Number */}
//         <div className="absolute left-8 top-1/2 transform -translate-y-1/2 opacity-10 pointer-events-none hidden lg:block">
//           <span className="text-9xl font-bold text-white">03</span>
//         </div>
        
//         <div className="flex-1 flex justify-center relative z-10">
//           <img
//             src="/comp_phone_mgmt.png"
//             alt="Management App"
//             className="w-full max-w-md lg:max-w-lg"
//           />
//         </div>
//         <div className="flex-1 max-w-2xl text-center lg:text-left space-y-6 relative z-10">
//           <p style={{ color: '#E2C163' }} className="uppercase text-sm tracking-wider font-medium">Where You Go Is The Key</p>
//           <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-tight">Management</h2>
//           <p className="text-lg leading-relaxed text-gray-300 max-w-xl">
//             To start print out the hiking guide and map. If it's raining, throw them in a Zip-lock bag. Read over the guide, study the map, and have a good idea of what to expect. I like to know what my next landmark is as I hike for example: I'll head to the guide and know that say ¼ mile I make a right turn on the trail and the trail goes...
//           </p>
//           <a href="#" style={{ color: '#E2C163' }} className="inline-flex items-center hover:opacity-80 transition group">
//             <span className="font-medium tracking-wide">read more</span>
//             <svg
//               className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform"
//               fill="none"
//               stroke="currentColor"
//               viewBox="0 0 24 24"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth={2}
//                 d="M17 8l4 4m0 0l-4 4m4-4H3"
//               />
//             </svg>
//           </a>
//         </div>
//       </section>

//       {/* Sign-Up Form */}
//       <section id="signup" className="relative min-h-screen py-20 px-6 md:px-12 flex items-center justify-center">
//         <div className="absolute inset-0" style={{ backgroundColor: 'rgba(0, 0, 0, 0.3)' }}></div>
//         <div className="w-full max-w-md">
//           <div className="p-8 rounded-2xl shadow-2xl backdrop-blur-sm" style={{ backgroundColor: 'rgba(37, 37, 37, 0.8)' }}>
//             <div className="space-y-5">
//               <input
//                 type="text"
//                 placeholder="First Name"
//                 className="w-full px-4 py-3 border border-gray-500 rounded-lg focus:outline-none transition placeholder-gray-400 text-white"
//                                   style={{ backgroundColor: 'rgba(37, 37, 37, 0.6)' }}
//               />
//               <input
//                 type="text"
//                 placeholder="Last Name"
//                 className="w-full px-4 py-3 border border-gray-500 rounded-lg focus:outline-none transition placeholder-gray-400 text-white"
//                 style={{ backgroundColor: 'rgba(0, 51, 51, 0.6)' }}
//               />
//               <input
//                 type="email"
//                 placeholder="Email"
//                 className="w-full px-4 py-3 border border-gray-500 rounded-lg focus:outline-none transition placeholder-gray-400 text-white"
//                 style={{ backgroundColor: 'rgba(0, 51, 51, 0.6)' }}
//               />
//               <input
//                 type="text"
//                 placeholder="Company/Club"
//                 className="w-full px-4 py-3 border border-gray-500 rounded-lg focus:outline-none transition placeholder-gray-400 text-white"
//                 style={{ backgroundColor: 'rgba(0, 51, 51, 0.6)' }}
//               />
//               <button 
//                 style={{ backgroundColor: '#E2C163', color: '#252525' }}
//                 className="w-full py-3 px-6 rounded-lg font-semibold hover:opacity-90 transition-opacity duration-200 shadow-lg"
//               >
//                 Sign Up
//               </button>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Footer */}
//       <footer className="py-16 px-6 text-gray-400" style={{ backgroundColor: '#000000' }}>
//         <div className="max-w-6xl mx-auto">
//           <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
//             <div className="md:col-span-2">
//               <h3 className="text-white text-2xl font-serif mb-4">Bracquets</h3>
//               <p className="text-gray-300 leading-relaxed max-w-md">
//                 Elevating your racquet club experience with intelligent coaching, top-tier equipment, and seamless management.
//               </p>
//             </div>
//             <div>
//               <h4 className="text-white text-sm uppercase tracking-wide font-medium mb-4">Navigation</h4>
//               <ul className="space-y-3">
//                 <li><a href="#section01" style={{ color: '#E2C163' }} className="hover:opacity-80 transition">Members</a></li>
//                 <li><a href="#section02" style={{ color: '#E2C163' }} className="hover:opacity-80 transition">Coaching</a></li>
//                 <li><a href="#section03" style={{ color: '#E2C163' }} className="hover:opacity-80 transition">Management</a></li>
//                 <li><a href="#signup" style={{ color: '#E2C163' }} className="hover:opacity-80 transition">Sign Up</a></li>
//               </ul>
//             </div>
//             <div>
//               <h4 className="text-white text-sm uppercase tracking-wide font-medium mb-4">Contact</h4>
//               <div className="space-y-2 text-sm">
//                 <p>123 Courtside Avenue<br />Tennis Valley, TX 77494</p>
//                 <p>contact@bracquets.com</p>
//                 <p>(555) 123-4567</p>
//               </div>
//             </div>
//           </div>
//           <div className="border-t pt-8 text-center text-sm text-gray-500" style={{ borderColor: 'rgba(37, 37, 37, 0.5)' }}>
//             © {new Date().getFullYear()} Bracquets. All rights reserved.
//           </div>
//         </div>
//       </footer>
//     </div>
//   );
// }



import React from 'react';

export default function BracquetsLanding() {
  return (
    <div className="font-sans text-white" style={{ background: 'linear-gradient(180deg, #252525 0%, #1a1a1a 25%, #111111 50%, #0a0a0a 75%, #000000 100%)' }}>
      {/* Navigation */}
      <header className="fixed top-0 left-0 w-full z-20 flex items-center justify-between px-6 py-4 bg-transparent backdrop-blur-sm">
        <h1 className="text-2xl font-serif tracking-widest text-white">Bracquets</h1>
        <nav className="hidden md:flex space-x-8 text-sm uppercase tracking-wide">
          <a href="#section01" style={{ color: '#E2C163' }} className="hover:opacity-80 transition">Members</a>
          <a href="#section02" style={{ color: '#E2C163' }} className="hover:opacity-80 transition">Coaches</a>
          <a href="#section03" style={{ color: '#E2C163' }} className="hover:opacity-80 transition">Management</a>
        </nav>
        <a
          href="#signup"
          style={{ backgroundColor: '#E2C163', color: '#252525' }}
          className="px-5 py-2 font-medium rounded-lg hover:opacity-90 transition"
        >
          Sign Up
        </a>
      </header>

      {/* Hero Section */}
      <section
        id="hero"
        className="relative h-screen bg-cover bg-center"
        style={{ backgroundImage: "url('/hero-landing.png')" }}
      >
        <div className="absolute inset-0" style={{ background: 'linear-gradient(to bottom, rgba(37, 37, 37, 0.9) 0%, rgba(37, 37, 37, 0.7) 50%, rgba(37, 37, 37, 0.9) 100%)' }} />
        <div className="relative z-10 h-full px-6 md:px-12 lg:px-20">
          <div className="pt-32 lg:pt-40">
            <div className="mb-8">
              <div className="w-20 h-px mb-4" style={{ backgroundColor: '#E2C163' }}></div>
              <p style={{ color: '#E2C163' }} className="uppercase text-sm tracking-widest font-medium">An Intelligent Experience</p>
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl leading-tight font-light max-w-2xl" style={{ fontFamily: 'Adamina, serif' }}>
              Redefined Racquet<br />Club Excellence
            </h1>
            <div className="mt-8">
              <a
                href="#section01"
                style={{ color: '#E2C163' }}
                className="inline-flex items-center lowercase text-sm tracking-wider hover:opacity-80 transition font-medium"
              >
                scroll down
                <svg
                  className="w-4 h-4 ml-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </a>
            </div>
          </div>
        </div>
        {/* Side Indicator */}
        <div className="hidden lg:flex absolute right-8 top-1/2 transform -translate-y-1/2 flex-col items-center text-xs tracking-widest space-y-3" style={{ color: '#E2C163' }}>
          <span className="font-medium">Start</span>
          <div className="w-px h-20 opacity-50" style={{ backgroundColor: '#E2C163' }}></div>
          <div className="space-y-3 text-right">
            <div>01</div>
            <div>02</div>
            <div>03</div>
          </div>
        </div>
      </section>

      {/* Section 01 - Members */}
      <section id="section01" className="relative min-h-screen py-20 flex items-center justify-center">
        <div className="flex w-full max-w-6xl mx-auto items-center relative">
          {/* Large Number */}
          <span
            className="hidden lg:block absolute"
            style={{
              left: '-4rem', // adjust as needed
              top: '50%',
              transform: 'translateY(-50%)',
              fontSize: '8rem',
              color: '#E2C163',
              opacity: 0.08,
              fontWeight: 700,
              lineHeight: 1,
              zIndex: 0,
              pointerEvents: 'none',
            }}
          >
            01
          </span>
          {/* Image */}
          <div className="flex-1 flex justify-center z-10">
            <img
              src="/members.png"
              alt="Members App"
              className="w-full max-w-md lg:max-w-lg"
            />
          </div>
          {/* Text */}
          <div className="flex-1 max-w-xl text-left space-y-6 z-10 ml-8">
            <p style={{ color: '#E2C163' }} className="uppercase text-sm tracking-wider font-medium">Get Started</p>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-tight">Members</h2>
            <p className="text-lg leading-relaxed text-gray-300">
            Empower your members with a seamless digital experience that makes club life effortless and engaging. From easy event sign-ups to real-time court bookings, our platform puts everything at their fingertips.<br></br> <br></br> Foster a vibrant community and keep your members coming back for more. Elevate your club’s value with features designed for tennis enthusiasts.
            </p>
            <a href="/" style={{ color: '#E2C163' }} className="inline-flex items-center hover:opacity-80 transition group">
              <span className="font-medium tracking-wide">read more</span>
              <svg
                className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M17 8l4 4m0 0l-4 4m4-4H3"
                />
              </svg>
            </a>
          </div>
        </div>
      </section>

      {/* Section 02 - Coaches */}
      <section id="section02" className="relative min-h-screen py-20 flex items-center justify-center">
        <div className="flex w-full max-w-6xl mx-auto items-center relative flex-row-reverse">
          {/* Large Number */}
          <span
            className="hidden lg:block absolute"
            style={{
              right: '-4rem', // adjust as needed
              top: '50%',
              transform: 'translateY(-50%)',
              fontSize: '8rem',
              color: '#E2C163',
              opacity: 0.08,
              fontWeight: 700,
              lineHeight: 1,
              zIndex: 0,
              pointerEvents: 'none',
            }}
          >
            02
          </span>
          {/* Image */}
          <div className="flex-1 flex justify-center z-10">
            <img
              src="/member2_mock@3x.png"
              alt="Coaches App"
              className="w-full max-w-md lg:max-w-lg"
            />
          </div>
          {/* Text */}
          <div className="flex-1 max-w-xl text-left space-y-6 z-10 mr-8">
            <p style={{ color: '#E2C163' }} className="uppercase text-sm tracking-wider font-medium">Hitting Essentials</p>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-tight">Coaches</h2>
            <p className="text-lg leading-relaxed text-gray-300">
            Give your coaching staff the tools they need to deliver world-class instruction and stay organized. Effortlessly manage lessons, track player progress, and communicate with members—all in one place. <br></br> <br></br> Our platform streamlines scheduling and notifications, so coaches can focus on what they do best: developing talent. Attract and retain top coaching talent with a system built for their success.
            </p>
            <a href="/" style={{ color: '#E2C163' }} className="inline-flex items-center hover:opacity-80 transition group">
              <span className="font-medium tracking-wide">read more</span>
              <svg
                className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M17 8l4 4m0 0l-4 4m4-4H3"
                />
              </svg>
            </a>
          </div>
        </div>
      </section>

      {/* Section 03 - Management */}
      <section id="section03" className="relative min-h-screen py-20 px-6 md:px-12 lg:px-20 flex flex-col lg:flex-row items-center justify-center gap-12 lg:gap-16">
        {/* Large Number */}
        <div className="absolute z-0 left-1/2 -translate-x-[60%] top-32 lg:top-1/2 lg:-translate-y-1/2 pointer-events-none hidden lg:block">
          <span className="text-[10rem] font-bold" style={{ color: '#E2C163', opacity: 0.08, lineHeight: 1 }}>03</span>
        </div>
        
        <div className="flex-1 flex justify-center relative z-10">
          <img
            src="/laptop2.png"
            alt="Management App"
            className="w-full max-w-md lg:max-w-lg"
          />
        </div>
        <div className="flex-1 max-w-2xl text-center lg:text-left space-y-6 relative z-10">
          <p style={{ color: '#E2C163' }} className="uppercase text-sm tracking-wider font-medium">Where You Go Is The Key</p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-tight">Management</h2>
          <p className="text-lg leading-relaxed text-gray-300 max-w-xl">
           Top-tier management. Transform your club’s operations with intelligent management features that save time and reduce hassle. From automated billing to facility scheduling and member analytics, our platform handles the details so you can focus on growth. <br></br> <br></br> Make data-driven decisions and deliver a premium experience to every member. Future-proof your club with technology that adapts as you grow.
          </p>
          <a href="/" style={{ color: '#E2C163' }} className="inline-flex items-center hover:opacity-80 transition group">
            <span className="font-medium tracking-wide">read more</span>
            <svg
              className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17 8l4 4m0 0l-4 4m4-4H3"
              />
            </svg>
          </a>
        </div>
      </section>

      {/* Sign-Up Form */}
      <section id="signup" className="relative min-h-screen py-20 px-6 md:px-12 flex items-center justify-center">
        <div className="absolute inset-0" style={{ backgroundColor: 'rgba(0, 0, 0, 0.3)' }}></div>
        <div className="w-full max-w-md">
          <div className="text-center mb-8">
            <h2 className="font-serif text-3xl md:text-4xl mb-4">Join Bracquets</h2>
            <p className="text-gray-300 text-lg">
              Sign up for early access and get to see how Bracquets can streamline member management, enhance coaching capabilities, and elevate your club's experience.
            </p>
          </div>
          <div className="p-8 rounded-2xl shadow-2xl backdrop-blur-sm" style={{ backgroundColor: 'rgba(37, 37, 37, 0.8)' }}>
            <div className="space-y-5">
              <input
                type="text"
                placeholder="First Name"
                className="w-full px-4 py-3 border border-gray-500 rounded-lg focus:outline-none transition placeholder-gray-400 text-white"
                style={{ backgroundColor: 'rgba(37, 37, 37, 0.6)' }}
              />
              <input
                type="text"
                placeholder="Last Name"
                className="w-full px-4 py-3 border border-gray-500 rounded-lg focus:outline-none transition placeholder-gray-400 text-white"
                style={{ backgroundColor: 'rgba(37, 37, 37, 0.6)' }}
              />
              <input
                type="email"
                placeholder="Email"
                className="w-full px-4 py-3 border border-gray-500 rounded-lg focus:outline-none transition placeholder-gray-400 text-white"
                style={{ backgroundColor: 'rgba(37, 37, 37, 0.6)' }}
              />
              <input
                type="text"
                placeholder="Company/Club"
                className="w-full px-4 py-3 border border-gray-500 rounded-lg focus:outline-none transition placeholder-gray-400 text-white"
                style={{ backgroundColor: 'rgba(37, 37, 37, 0.6)' }}
              />
              <button 
                style={{ backgroundColor: '#E2C163', color: '#252525' }}
                className="w-full py-3 px-6 rounded-lg font-semibold hover:opacity-90 transition-opacity duration-200 shadow-lg"
              >
                Sign Up
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-16 px-6 text-gray-400" style={{ backgroundColor: '#000000' }}>
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
            <div className="md:col-span-2">
              <h3 className="text-white text-2xl font-serif mb-4">Bracquets</h3>
              <p className="text-gray-300 leading-relaxed max-w-md">
                Elevate your racquet club experience with intelligent coaching, top-tier communication, and seamless management.
              </p>
            </div>
            <div>
              <h4 className="text-white text-sm uppercase tracking-wide font-medium mb-4">Navigation</h4>
              <ul className="space-y-3">
                <li><a href="#section01" style={{ color: '#E2C163' }} className="hover:opacity-80 transition">Members</a></li>
                <li><a href="#section02" style={{ color: '#E2C163' }} className="hover:opacity-80 transition">Coaching</a></li>
                <li><a href="#section03" style={{ color: '#E2C163' }} className="hover:opacity-80 transition">Management</a></li>
                <li><a href="#signup" style={{ color: '#E2C163' }} className="hover:opacity-80 transition">Sign Up</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-white text-sm uppercase tracking-wide font-medium mb-4">Contact</h4>
              <div className="space-y-2 text-sm">
                {/* <p>123 Courtside Avenue<br />Tennis Valley, TX 77494</p> */}
                <p>contact@bracquets.com</p>
                {/* <p>(555) 123-4567</p> */}
              </div>
            </div>
          </div>
          <div className="border-t pt-8 text-center text-sm text-gray-500" style={{ borderColor: 'rgba(37, 37, 37, 0.5)' }}>
            © {new Date().getFullYear()} Bracquets. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
}